module.exports = __webpack_public_path__ + "static/media/TCF.d2244bb6.webp";